<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('utils.lunlog40')"
      @backurl="$router.back()"
    />
    
    <div class="main_wrap">
      <!-- ================= 表单大卡片 ================= -->
      <div class="card_box form_card">
        <form class="form">
          
          <!-- 1. 邮箱 (已锁定) -->
          <div class="form_item">
            <label class="field_label">{{ $t('utils.lunlog34') }}</label>
            <div class="input_wrap readonly">
              <input v-model.trim="email" type="text" class="inp" readonly>
            </div>
          </div>

          <!-- 2. 验证码 (带右侧按钮) -->
          <div class="form_item">
            <label class="field_label">{{ $t('auth.emailCode') }}</label>
            <div class="code_row">
              <div class="input_wrap code_input">
                <input v-model.trim="account.code" type="text" class="inp" :placeholder="$t('auth.emailCode')">
              </div>
              <van-count-down :time="time" @finish="timeCall">
                <template v-slot="timeData">
                  <span 
                    class="send_btn" 
                    :class="{ disabled: is_send || timeData.seconds > 0 }"
                    @click="sendcode"
                  >
                    {{ timeData.seconds > 0 ? timeData.seconds + 's' : $t('auth.sendEmailCode') }}
                  </span>
                </template>
              </van-count-down>
            </div>
          </div>

          <!-- 3. 银行 (下拉框) -->
          <div class="form_item">
            <label class="field_label">{{ $t('wallet.bank') }}</label>
            <div class="input_wrap select_wrap">
              <van-dropdown-menu class="custom_dropdown">
                <van-dropdown-item v-model="value1" :options="option1" />
              </van-dropdown-menu>
              <div class="select_arrow">›</div>
            </div>
          </div>

          <!-- 4. 姓名 -->
          <div class="form_item">
            <label class="field_label">{{ $t('wallet.name') }}</label>
            <div class="input_wrap">
              <input 
                v-model="account.name" 
                type="text" 
                class="inp" 
                :placeholder="$t('wallet.namePlaceholder')"
              >
            </div>
          </div>

          <!-- 5. 卡号 -->
          <div class="form_item">
            <label class="field_label">{{ $t('wallet.account') }}</label>
            <div class="input_wrap">
              <input 
                v-model="account.account" 
                type="text" 
                class="inp" 
                :placeholder="$t('wallet.accountPlaceholder')"
              >
            </div>
          </div>
        </form>
      </div>

      <!-- ================= 底部红色文字提示 ================= -->
      <div class="warning_box">
        <p class="tip_red">
          <span>*</span>{{ $t('wallet.walletTips1') }}
        </p>
      </div>
      
      <!-- ================= 操作按钮 (正常文档流，跟随页面) ================= -->
      <div class="action_btn_wrap">
        <div 
          class="action_btn"
          :class="account.name==''||account.account==''?'disabled':''"
          @click="submit()"
        >
          {{ $t('wallet.bindNow') }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { CountDown, DropdownMenu, DropdownItem } from "vant";

Vue.use(DropdownMenu).use(DropdownItem).use(CountDown);

export default {
  name: "WalletBank",
  components: { bsHeader },
  data() {
    return {
      data: [],
      account: {
        id: '', bank: '', name: '', account: '', band_id: 0, bank_id: '', code: '',
      },
      time: 0,
      email: '',
      code: '',
      value1: 0,
      option1: [],
      is_send: false
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
    this.starts();
  },
  methods: {
    starts() {
      Fetch('/user/getAuthStatus').then((r) => {
        this.data = r.data; 
        this.email = r.data.email;
      });
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    start() {
      Fetch('/user/getWithdrawMethodById', {
        id: this.$router.history.current.params.code
      }).then(r => {
        this.account.id = r.data.withdraw.id;
        var banks = r.data.withdraw.banks;
        if (r.data.withdraw.band) {
          var band = r.data.withdraw.band;
          this.account.band_id = r.data.withdraw.band.id;
          this.account.account = r.data.withdraw.band.account;
          this.account.name = r.data.withdraw.band.name;
          for (var i = 0; i < r.data.withdraw.banks.length; i++) {
            if (r.data.withdraw.band['bid'] == r.data.withdraw.banks[i]['id']) {
              this.value1 = i;
            }
          }
        }
        for (var i = 0; i < banks.length; i++) {
          this.option1.push({
            text: banks[i].name,
            value: i,
            code: banks[i].code,
            id: banks[i].id
          })
        }
      })
    },
    sendcode() {
      if (this.is_send) return false;
      if (!this.email) {
        this.$toast(this.$t('auth.emailEmpty'));
        return false;
      }
      var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.email)) {
        this.$toast(this.$t('auth.emailError'));
        return false;
      }
      this.is_send = true;
      Fetch("/user/getEmailCode", { email: this.email }).then(() => {
        this.time = 60 * 1000;
        this.$toast({ background: "#07c160", message: this.$t('auth.sendsuccess') });
      }).catch(() => {
        this.is_send = false;
      });
    },
    submit() {
      this.account.bank = this.option1[this.value1]['text'];
      this.account.bank_id = this.option1[this.value1]['id'];
      if (this.account.name.length > 16 || this.account.name.length < 2) {
        this.$toast(this.$t('wallet.nameError')); return false;
      }
      if (this.account.account.length > 20 || this.account.account.length < 6) {
        this.$toast(this.$t('wallet.accountError')); return false;
      }
      var reg1 = /^[0-9]*$/;
      if (!reg1.test(this.account.account)) {
        this.$toast(this.$t('wallet.accountError')); return false;
      }
      Fetch('/user/setWallet', { ...this.account }).then(r => {
        if (r.code == '218') {
          this.$toast(this.$t(r.info)); return false;
        } else {
          this.$router.replace('/user')
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  position: relative;
  height: 100vh;           /* 确保占满整个屏幕高度 */
  overflow-y: auto;        /* 【核心修复】：允许内部内容上下滚动 */
  -webkit-overflow-scrolling: touch; /* 手机端顺畅滚动 */
background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
  padding-bottom: 60px;    /* 底部留白，看到按钮 */
}

.main_wrap {
  padding: 20px 16px 0;
}

/* ================= 通用白色卡片 ================= */
.card_box {
  background: #ffffff;
  border-radius: 18px;
  padding: 24px 20px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.06);
  margin-bottom: 16px;
  border: 1px solid rgba(176, 202, 240, 0.3);
}

/* ================= 表单区核心样式 ================= */
.form_card {
  .form {
    width: 100%;
    .form_item {
      margin-bottom: 20px;
      .field_label {
        display: block;
        font-size: 15px;
        font-weight: 700;
        color: #1a2742;
        margin-bottom: 10px;
        padding-left: 2px;
      }

      /* 核心输入框容器 */
      .input_wrap {
        width: 100%;
        background: #f1f5f9; 
        border-radius: 12px;
        height: 52px;
        display: flex;
        align-items: center;
        border: 1px solid transparent; 
        padding: 0 16px; 
        box-sizing: border-box;
        position: relative;
        
        &.readonly {
          background: #f1f5f9; 
        }

        /* 原生的 input 重写，保持高度一致 */
        .inp {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
          font-size: 15px;
          font-weight: 500;
          color: #1a2742;
          &::placeholder { 
            color: #94a3b8; 
            font-weight: 400; 
          }
          &:read-only { 
            color: #64748b; 
          }
        }
      }
    }
  }
}

/* ================= 验证码区域 ================= */
.code_row {
  display: flex;
  gap: 12px;
  align-items: stretch;
  
  .code_input {
    flex: 1;
    padding: 0 16px !important;
  }
  
  .send_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 52px;
    width: 110px;
    background: #ffffff;
    border: 1px solid #8fb0ff;
    color: #2563eb;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    box-sizing: border-box;
    
    &:active { opacity: 0.7; transform: scale(0.96); }
    &.disabled {
      background: #f1f5f9;
      color: #94a3b8;
      border-color: #e2e8f0;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}

/* ================= 下拉菜单重写 (银行选择) ================= */
.custom_dropdown.van-dropdown-menu {
  width: 100%;
  height: 100%;
  background: transparent !important;
  box-shadow: none !important;
  
  .van-dropdown-menu__bar {
    height: 100%;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0;
    display: flex;
    align-items: center;
  }
  
  .van-dropdown-menu__title {
    color: #1a2742;
    font-size: 15px;
    font-weight: 500;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    
    &::after {
      display: none !important;
    }
  }
  
  .van-dropdown-menu__title--active {
    color: #1a2742;
  }
}
/deep/ .van-dropdown-item__content {
  background: #ffffff;
  border-radius: 12px;
  margin-top: 6px;
}
/deep/ .van-popup--top { background: transparent !important; }

.select_wrap {
  padding-right: 16px !important;
}
.select_arrow {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 20px;
  font-weight: 300;
  pointer-events: none;
}

/* ================= 底部警告文字 ================= */
.warning_box {
  margin-bottom: 20px;
  padding: 0 4px;
  line-height: 1.6;
  .tip_red {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-size: 13px;
    color: #dc2626;
    font-weight: 500;
    span { color: #dc2626; }
  }
}

/* ================= 操作按钮 (正常文档流，跟随页面布局) ================= */
.action_btn_wrap {
  margin-bottom: 30px; /* 与页面底部保留足够距离 */
}

.action_btn {
  width: 100%;
  height: 52px;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  background: linear-gradient(135deg, #77a8ff 0%, #4e7dff 100%);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
  
  &:active { transform: scale(0.96); opacity: 0.9; }
  &.disabled { opacity: 0.6; pointer-events: none; }
}
/* ================= 下拉菜单重写 (银行选择) ================= */
.custom_dropdown.van-dropdown-menu {
  width: 100%;
  height: 100%;
  background: transparent !important;
  box-shadow: none !important;
  
  /* 去掉默认的白色条与边距 */
  .van-dropdown-menu__bar {
    height: 100%;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  
  /* 定制选中文字样式 */
  .van-dropdown-menu__title {
    color: #1a2742;
    font-size: 15px;
    font-weight: 500;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    
    /* 彻底隐藏 Vant 自带的向下的小三角 */
    &::after {
      display: none !important;
      content: none !important;
      border: none !important;
    }
  }
  
  .van-dropdown-menu__title--active {
    color: #1a2742;
  }
}

/* 下拉展开的面板圆角 */
/deep/ .van-dropdown-item__content {
  background: #ffffff;
  border-radius: 12px;
  margin-top: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* 去掉外层半透明遮罩，保持清爽 */
/deep/ .van-popup--top { 
  background: transparent !important; 
}

/* ================= 右侧自定义箭头 (保持不变) ================= */
.select_wrap {
  padding-right: 16px !important;
}
.select_arrow {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 20px;
  font-weight: 300;
  pointer-events: none;
  z-index: 2; /* 放在最上层，确保箭头可见 */
}
</style>